export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { pageName: 'Login', actionName: 'Login' }
  }
]
